<template>
  <section v-if="mediaList.length > 0" class="main-news">
    <div class="main-title">
      <html-view :value="$t('main.news.title')" tag="h3" />
    </div>
    <div class="main-content">
      <div class="list list-default">
        <div v-for="(item, key) in mediaList" :key="key" class="list-box">
          <!--          <router-link :to="{name: 'newsroomReportDetail', params: {newsroomId: item.reportSeq}}">-->
          <a href="#" @click.prevent="linkTo(item.reportSeq)">
            <div class="list-thumb"><img :src="item.reportImagePath" alt="" @error.once="onImageError"></div>
            <div class="list-cont">
              <p class="list-title">{{ item.reportTitle }}</p>
              <p v-if="item.reportSubTitle && item.reportSubTitle.trim().length > 0" class="list-desc">{{ item.reportSubTitle }}</p>
              <div>
                <time class="list-date">{{ item.reportDistributeDay | dateFormat }}</time>
              </div>
            </div>
          </a>
          <!--          </router-link>-->
        </div>
        <div v-if="mediaList.length <= 0" class="empty">
          empty
        </div>
      </div>

      <router-link
        tag="button"
        :to="{name: 'NewsroomReport', query: {page:1}, params : { 'locale' : locale === 'en' ? 'en' : undefined }}"
        class="btn btn-more"
        @click.native="goTop"
      >
        {{ $t('detail.seeMore') }}
      </router-link>
    </div>
  </section>
</template>

<script>
import newsroomApi from '@/api/newsroom'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    prevRoute: {
      type: String || null || undefined,
      default: null
    },
  },
  data () {
    return {
      defaultImgPath: require('@/static/image/default.jpg'),
      mediaList: [],
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE',
      topPosition: 'positionTop/GET_POSITION_TOP',
      savePage: 'positionTop/GET_SAVE_PATE'
    }),
  },
  watch: {
    '$route.params.locale' () {
      this.getReport()
    }
  },
  mounted () {
    this.getReport().then(() => {
      if (this.savePage.indexOf(this.prevRoute) !== -1) {
        // TODO main에서 report detail를 갔다가 report list로 가는경우 메인에서 저장한 topPosition의 위치고 list의 위치가 옮겨지는 문제가 있음..
        window.scrollTo(0, this.topPosition)
      }
    })
  },
  methods: {
    ...mapActions({
      positionTopChange: 'positionTop/positionTopChange'
    }),
    async getReport () {
      const { data } = await newsroomApi.getReport({
        pageNumber: 1,
        pageSize: 3,
        sort: 'reportDistributeDay,desc'
      })

      this.mediaList = data.list
    },
    linkTo (reportSeq) {
      this.positionTopChange(window.pageYOffset)
      this.$router.push({ name: 'newsroomReportDetail', params: { locale: this.$route.params.locale, newsroomId: reportSeq } })
    },
    goTop () {
      document.documentElement.scrollTop = 0
    },
    onImageError (e) {
      e.target.src = this.defaultImgPath
    }
  }
}
</script>
